import React, { memo } from 'react'
import { Grid, Typography, Box, Button } from '@mui/material'
import { translate } from '../i18n'
import { ExternSurfaceProps } from './ExternSurface.types'
import Logo from './Logo'

function ExternSurface({
    title,
    description,
    children,
    showTitle,
    sm = 10,
    md = 6,
    lg = 4,
    xl = 3,
}: ExternSurfaceProps) {
    return (
        <Grid item xs={12} sm={sm} md={md} lg={lg} xl={xl}>
            <Box my={4}>
                <Grid container justifyContent="center" alignItems="center">
                    <Grid item xs={11} lg={12}>
                        <Grid
                            container
                            justifyContent="center"
                            alignItems="center"
                        >
                            <Logo
                                text={translate('app.title') as string}
                                variant="extern"
                            />
                            <Grid item xs={12}>
                                {showTitle && title && (
                                    <Box mb={3}>
                                        <Typography
                                            component="h5"
                                            variant="h5"
                                            align="center"
                                        >
                                            {title}
                                        </Typography>
                                    </Box>
                                )}
                                {description && (
                                    <Typography
                                        component="p"
                                        variant="body1"
                                        align="center"
                                    >
                                        {description}
                                    </Typography>
                                )}
                            </Grid>
                        </Grid>
                        {children}
                        <Grid
                            container
                            justifyContent="space-between"
                            alignItems="center"
                            sx={{ mt: 8 }}
                        >
                            <Grid item xs="auto">
                                <Button
                                    component="a"
                                    variant="text"
                                    color="inherit"
                                    size="small"
                                    href="mailto:arsupport@pixlbank.com"
                                >
                                    {translate('buttons.contact')}
                                </Button>
                            </Grid>
                            <Grid item xs="auto">
                                <Button
                                    component="a"
                                    variant="text"
                                    color="inherit"
                                    size="small"
                                    href="https://www.pixlbank.com/ar-privacy-policy"
                                    target="_blank"
                                >
                                    {translate('buttons.privacy_policy')}
                                </Button>
                            </Grid>
                            <Grid item xs="auto">
                                <Button
                                    component="a"
                                    variant="text"
                                    color="inherit"
                                    size="small"
                                    href="https://www.pixlbank.com/ar-terms-and-conditions"
                                    target="_blank"
                                >
                                    {translate('buttons.terms_conditions')}
                                </Button>
                            </Grid>
                            <Grid item xs={12} sx={{ mt: 2 }}>
                                <Typography
                                    component="h6"
                                    variant="caption"
                                    color="primaryText"
                                    textAlign="center"
                                >
                                    {translate('auth.copyright', {
                                        year: new Date().getFullYear(),
                                        suffix: '[ar]',
                                    })}
                                </Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Box>
        </Grid>
    )
}

export default memo(ExternSurface)
